import { cn } from '@/lib/classnames';
import { useThumbnail } from '@/browser/query';
import styles from './badge.module.css';

export const Badge = ({
  name,
  className,
}: {
  name: string;
  className?: string;
}) => {
  const { data: thumbnail } = useThumbnail(name);
  return (
    <div
      data-component="badge"
      className={ cn(styles.badge, className) }
      style={ { backgroundImage: thumbnail ? `url(${thumbnail})` : undefined } }
    />
  );
};